/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_Fitness_TermsInputs */

const en_service_type_group_fitness_terms = /** @type {(inputs: Service_Type_Group_Fitness_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fitness classes, group classes, aerobics, body pump, tabata, hiit, intervals`)
};

const pl_service_type_group_fitness_terms = /** @type {(inputs: Service_Type_Group_Fitness_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fitness, zajęcia grupowe, aerobik, zdrowy kręgosłup, body pump, tabata, hiit, interwały`)
};

/**
* | output |
* | --- |
* | "fitness classes, group classes, aerobics, body pump, tabata, hiit, intervals" |
*
* @param {Service_Type_Group_Fitness_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_fitness_terms = /** @type {((inputs?: Service_Type_Group_Fitness_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_Fitness_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_fitness_terms(inputs)
	return en_service_type_group_fitness_terms(inputs)
});